import {createAction} from '@reduxjs/toolkit'
import {bulkAction} from '@wix/panda-js-utils'
import {MembersModal, ModalResponse, getEventId} from '@wix/wix-events-commons-statics'
import {getLanguage} from '../../../../commons/selectors/environment'
import {openModal} from '../../../../commons/services/modal'
import {getRealEvents} from '../selectors/events'
import {createAsyncAction} from '../services/redux-toolkit'

export const ensureLoggedIn = createAsyncAction<boolean, void>(
  'ENSURE_LOGGED_IN',
  async (_, {dispatch, extra: {wixCodeApi}}) =>
    !wixCodeApi.user.currentUser.loggedIn ? dispatch(promptLogin()).unwrap() : true,
)

export const promptLogin = createAsyncAction<boolean, void>('PROMPT_LOGIN', async (_, {getState, extra: {serverApi}}) =>
  serverApi.promptLogin(getLanguage(getState())),
)

export const loadMembersForEvents = createAsyncAction<GuestLists>(
  'LOAD_MEMBERS_FOR_EVENTS',
  async (_, {getState, extra: {serverApi}}) => {
    const responses = await bulkAction(getRealEvents(getState()).map(getEventId), eventIds =>
      serverApi.getGuestLists(eventIds),
    )

    return responses.reduce((guestLists, chunk) => ({...guestLists, ...chunk}), {})
  },
)

export const openMembersModal = createAsyncAction<ModalResponse, string>(
  'OPEN_MEMBERS_MODAL',
  async (eventId, {dispatch}) => {
    const loggedIn = await dispatch(ensureLoggedIn()).unwrap()
    if (loggedIn) {
      return dispatch(openModal({type: MembersModal.LIST, params: {eventId}})).unwrap()
    }
  },
)

export const memberLoggedIn = createAction('MEMBER_LOGGED_IN')
